import React from 'react';
import QuestionCard from '../forms/QuestionCard';
import { useFormContext } from '../../context/FormContext';

const AchievementSatisfactionQuestions = ({
  questionNumber,
  categories,
  totalQuestions
}) => {
  const { formData, handleInputChange } = useFormContext();
  
  switch(questionNumber) {
    case 1:
      return (
        <QuestionCard 
          categoryIcon={categories[7].icon}
          categoryName={categories[7].name}
          questionNumber={1}
          totalQuestions={totalQuestions}
          title="回顾你过去一年最有成就感的几件事。这些经历有什么共同特征? 什么元素让你感到特别有满足感？" 
          subtitle="（例如：解决难题、帮助他人、创造新事物、获得认可，还是达成目标等?）"
          value={formData.achievementExperiences}
          onChange={(value) => handleInputChange('achievementExperiences', value)}
          inputType="textarea"
        />
      );
    case 2:
      return (
        <QuestionCard 
          categoryIcon={categories[7].icon}
          categoryName={categories[7].name}
          questionNumber={2}
          totalQuestions={totalQuestions}
          title="想象你负责一个完全按照自己想法来做的项目。什么样的成果会让你觉得&quot;这真是个成功的项目&quot;？" 
          subtitle="（可多选）"
          inputType="checkbox"
          options={[
            "A. 它很有创新性",
            "B. 它对他人产生了积极影响",
            "C. 你自己学到了很多新东西",
            "D. 它得到了很多人的认可/赞赏",
            "E. 它创造了持久的效果"
          ]}
          customOption={true}
          customValue={formData.successCriteriaOther}
          onCustomChange={(value) => handleInputChange('successCriteriaOther', value)}
          value={formData.successCriteria}
          onChange={(values) => handleInputChange('successCriteria', values)}
        />
      );
    case 3:
      return (
        <QuestionCard 
          categoryIcon={categories[7].icon}
          categoryName={categories[7].name}
          questionNumber={3}
          totalQuestions={totalQuestions}
          title="在选择理想工作时，哪些因素对你来说最重要？" 
          subtitle="（可多选，最多3个）"
          inputType="checkbox"
          options={[
            "A. 高薪资",
            "B. 社会地位/身份感（prestige、头衔）",
            "C. 稳定、有安全感",
            "D. 对社会/他人产生积极影响",
            "E. 有挑战性、能快速成长/学到新东西的工作",
            "F. 工作与生活平衡",
            "G. 有自由发挥自己想法的空间，不被严格规定怎么做",
            "H. 团队归属感、融入感",
            "I. 成就感（证明自己能成大事）"
          ]}
          customOption={true}
          customValue={formData.jobFactorsOther}
          onCustomChange={(value) => handleInputChange('jobFactorsOther', value)}
          value={formData.jobFactors}
          onChange={(values) => {
            // Limit to maximum 3 selections
            if (Array.isArray(values) && values.length <= 3) {
              handleInputChange('jobFactors', values);
            } else if (Array.isArray(values) && values.length > 3) {
              // Keep only the first 3 selections
              handleInputChange('jobFactors', values.slice(0, 3));
            }
          }}
        />
      );
    default:
      return null;
  }
};

export default AchievementSatisfactionQuestions;